// var extend = require('./util').extend;

var Timer = function (options) {
    options = options || {};
    options.duration = options.duration || 2e3;
    options.onElapsed = options.onElapsed || function () {
    };

    this._timer = null;    // 获取新消息的定时器
    this._options = options;

    /*(function (self) {
        var defaults = {
            onElapsed: function (cb) {    // 到达时间后执行的任务
                cb();
            },
            duration: 2000    // 时间间隔，单位：毫秒
        };
        extend(defaults, options);
        self._options = defaults;
    })(this);*/
};
Timer.prototype.setDuration = function (duration) {
    this._options.duration = duration;
};
Timer.prototype.start = function () {
    if (this._timer)
        return;

    var self = this;
    /*var lasttime = Date.now();*/
    (function execute() {
        /*var now = Date.now();
         console.log('timer:上次执行职务' + ( now - lasttime ) + '前');
         lasttime = now;*/

        self._options.onElapsed(function () {
            self._timer = setTimeout(function () {
                execute();
            }, self._options.duration);
        });
    })();
};
Timer.prototype.stop = function () {
    clearTimeout(this._timer);
    this._timer = null;
};
Timer.prototype.restart = function () {
    this.stop();
    this.start();
};

module.exports = Timer;
